<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-12', 'col-md-12', 'icon-box']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-3']">Quienes somos</h3>
                                <div :class="['row']">
                                    <div :class="['col-lg-8']">
                                        <p :class="['text-justify']" v-html="Quienes_somos.contenido"></p>	
                                    </div>
                                    
                                    <div :class="['col-lg-4']">
                                        <img :src="empresa.path_file_logo" class="img-fluid">
                                    </div>
                                </div>
                                
                                <div :class="['row']">
                                    <div :class="['col-lg-6', 'text-justify']">
                                        <h4><u>Misión</u></h4>
                                        <p v-html="Mision.contenido"></p>
                                    </div>
                                
                                    <div :class="['col-lg-6', 'text-justify']">
                                        <h4><u>Vision</u></h4>
                                        <p v-html="Vision.contenido"></p>
                                    </div>
                                </div>
                            
                                <hr>
                                <div :class="['row']">
                                    <div :class="['col-lg-8', 'mt-1']">
                                        <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-1']">Nuestra historia</h3>
                                        <p :class="['text-justify']" v-html="Historia.contenido"></p>	
                                    </div>
                                    
                                    <div :class="['col-lg-4', 'align-items-center', 'justify-content-center', 'my-auto']">
                                        <img :class="['my-auto', 'img-fluid']" :src="Historia.path_file_imagen">
                                    </div>
                                </div>

                                <div :class="['row']">
                                    <div :class="['col-lg-12', 'mt-2']">
                                        <table :class="['table', 'table-striped', 'table-condensed', 'text-justify']">
                                            <tr>
                                                <td><b>RUC</b></td>
                                                <td>{{empresa.ruc}}</td>
                                            </tr>

                                            <tr>
                                                <td colspan="2"><b>SUCURSALES</b></td>
                                            </tr>
                                            
                                            <tr v-for="(val, key) in empresa.sucursales" :key="key">
                                                <td >
                                                    <strong class="ml-4">{{val.descripcion}}</strong>
                                                </td>

                                                <td>
                                                    <table border="0" >
                                                        <tr>
                                                            <td style="border:0px"><b>Horario:</b></td>
                                                            <td style="border:0px">{{val.horario_atencion}} </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="border:0px"><b>Dirección:</b></td>
                                                            <td style="border:0px">{{val.direccion}} </td>
                                                        </tr>

                                                        <tr>
                                                            <td><b>Telefono:</b></td>
                                                            <td>{{val.telefono}} </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td><b>CORREO ELECTRÓNICO</b></td>
                                                <td>{{empresa.email}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'Nostros',
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Nosotros || "+this.empresa.abreviatura;
            this.getNosotros();
        },
        data(){
            return{
                Quienes_somos:{
                    contenido:""
                },
                Mision:{
                    contenido:""
                },
                Vision:{
                    contenido:""
                },
                Historia:{
                    contenido:""
                },
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            getNosotros(){
                this.setLoading(true);
                
                this.$http.get('webserviceserver/nosotros').then((res)=>{
                    if(res.data.About_us)
                        this.Quienes_somos  = res.data.About_us;
                    if(res.data.Mision)
                        this.Mision         = res.data.Mision;
                    if(res.data.Vision)
                        this.Vision         = res.data.Vision;
                    if(res.data.History)
                        this.Historia       = res.data.History;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>